import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import UserProfile from "../UserProfile/UserProfile";
import ChangeWorkspaceModal from "../Workspaces/ChangeWorkspaceModal";
import RequestWorkspaceModal from "../Workspaces/RequestWorkspaceModal";
import RequestWorkspaceOtpModal from "../Modals/RequestWorkspaceOtpModal";
import Modal from "../Modals/Modal";
import NotificationComponent from "./NotificationComponent";
import signalRService from "./signalRService";

import "./DashboardMenu.css";
import ProjectManagement from "../Projects/ProjectManagement";
import JobManagment from "../Jobs/JobManagment";
import UserManagement from "../Users/UserManagement";
import JobPermissionManagement from "../JobPermission/JobPermissionManagement";
import JobStatusManagement from "../JobStatus/JobStatusManagement";
import WorkspaceManagement from "../Workspaces/WorkspaceManagement";
import ProjectPermissionManagement from "../ProjectPermission/ProjectPermissionManagement";
import WorkspacePermissionManagement from "../WorkspacePermission/WorkspacePermissionManagement";

const DashboardMenu = React.memo(
  ({
    defaultUserWorkspaceID,
    defaultUserWorkspaceName,
    onUpdateDefaultWorkspace,
    userid,
    onLogout,
  userRole,
  searchTerm,
  setSearchTerm,
  handleSearchKeyDown,
  handleClearSearch,

  searchColumn,
  setSearchColumn,
  viewMode,
  setViewMode,
  handleRefresh,
  handleNewTaskModal,
  defWorkName,
  refreshNotes,
  onHighlightNote,
}) => {
  const [showUserProfileModal, setShowUserProfileModal] = useState(false);
  const [showChangeWorkspaceModal, setShowChangeWorkspaceModal] =
    useState(false);
  const [showRequestWorkspaceModal, setShowRequestWorkspaceModal] =
    useState(false);
  const [showRequestWorkspaceOtpModal, setShowRequestWorkspaceOtpModal] =
    useState(false);
  const [verifiedEmail, setVerifiedEmail] = useState("");
  const [isRoleLoading, setIsRoleLoading] = useState(false);
  const [userWorkspaces, setUserWorkspaces] = useState();
  const [role, setRole] = useState(null);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  // State for active settings component
  const [activeSettingsComponent, setActiveSettingsComponent] = useState(null);
  const [settingsModalTitle, setSettingsModalTitle] = useState("Settings");
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  // State for submenus
  const [showJobSubmenu, setShowJobSubmenu] = useState(false);
  const [showProjectSubmenu, setShowProjectSubmenu] = useState(false);
  const [showWorkspaceSubmenu, setShowWorkspaceSubmenu] = useState(false);
  const [jobSubmenuPosition, setJobSubmenuPosition] = useState({
    top: 0,
    left: 0,
  });
  const [projectSubmenuPosition, setProjectSubmenuPosition] = useState({
    top: 0,
    left: 0,
  });
  const [workspaceSubmenuPosition, setWorkspaceSubmenuPosition] = useState({
    top: 0,
    left: 0,
  });

  const [isMobile, setIsMobile] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showViewOptions, setShowViewOptions] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const userMenuRef = useRef(null);
  const userAvatarRef = useRef(null);
  const viewOptionsRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const searchRef = useRef(null);
  const settingsMenuRef = useRef(null);
  const settingsButtonRef = useRef(null);
  const mobileSettingsButtonRef = useRef(null);
  const jobMenuButtonRef = useRef(null);
  const projectMenuButtonRef = useRef(null);
  const jobSubmenuRef = useRef(null);
  const projectSubmenuRef = useRef(null);
  const workspaceMenuButtonRef = useRef(null);
  const workspaceSubmenuRef = useRef(null);
  const notificationsRef = useRef(null);
  const notificationsButtonRef = useRef(null);

  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api`;
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Custom hook for detecting clicks outside
  const useClickOutside = (ref, handler) => {
    useEffect(() => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };

      document.addEventListener("mousedown", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
      };
    }, [ref, handler]);
  };

  // Handle click outside settings menu
  const handleClickOutsideSettings = useCallback(
    (event) => {
      const isClickOnSettingsButton =
        (settingsButtonRef.current &&
          settingsButtonRef.current.contains(event.target)) ||
        (mobileSettingsButtonRef.current &&
          mobileSettingsButtonRef.current.contains(event.target));

      if (!isClickOnSettingsButton && showSettingsMenu) {
        setShowSettingsMenu(false);
      }
    },
    [showSettingsMenu],
  );

  // Handle click outside user menu
  const handleClickOutsideUserMenu = useCallback(
    (event) => {
      const isClickOnUserAvatar =
        userAvatarRef.current && userAvatarRef.current.contains(event.target);

      if (!isClickOnUserAvatar && showUserMenu) {
        setShowUserMenu(false);
      }
    },
    [showUserMenu],
  );

  // Handle click outside job submenu
  const handleClickOutsideJobSubmenu = useCallback(
    (event) => {
      const isClickOnJobMenuButton =
        jobMenuButtonRef.current &&
        jobMenuButtonRef.current.contains(event.target);

      if (!isClickOnJobMenuButton && showJobSubmenu) {
        setShowJobSubmenu(false);
      }
    },
    [showJobSubmenu],
  );

  // Handle click outside project submenu
  const handleClickOutsideProjectSubmenu = useCallback(
    (event) => {
      const isClickOnProjectMenuButton =
        projectMenuButtonRef.current &&
        projectMenuButtonRef.current.contains(event.target);

      if (!isClickOnProjectMenuButton && showProjectSubmenu) {
        setShowProjectSubmenu(false);
      }
    },
    [showProjectSubmenu],
  );

  // Handle click outside workspace submenu
  const handleClickOutsideWorkspaceSubmenu = useCallback(
    (event) => {
      const isClickOnWorkspaceMenuButton =
        workspaceMenuButtonRef.current &&
        workspaceMenuButtonRef.current.contains(event.target);

      if (!isClickOnWorkspaceMenuButton && showWorkspaceSubmenu) {
        setShowWorkspaceSubmenu(false);
      }
    },
    [showWorkspaceSubmenu],
  );

  // Handle click outside notifications
  const handleClickOutsideNotifications = useCallback(
    (event) => {
      const isClickOnNotificationsButton =
        notificationsButtonRef.current &&
        notificationsButtonRef.current.contains(event.target);

      if (!isClickOnNotificationsButton && showNotifications) {
        setShowNotifications(false);
      }
    },
    [showNotifications],
  );

  // Apply click outside handlers
  useClickOutside(settingsMenuRef, handleClickOutsideSettings);
  useClickOutside(userMenuRef, handleClickOutsideUserMenu);
  useClickOutside(jobSubmenuRef, handleClickOutsideJobSubmenu);
  useClickOutside(projectSubmenuRef, handleClickOutsideProjectSubmenu);
  useClickOutside(workspaceSubmenuRef, handleClickOutsideWorkspaceSubmenu);
  useClickOutside(notificationsRef, handleClickOutsideNotifications);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close view options when clicking outside
      if (
        viewOptionsRef.current &&
        !viewOptionsRef.current.contains(event.target) &&
        !event.target.closest(".view-options-button")
      ) {
        setShowViewOptions(false);
      }

      // Close mobile menu when clicking outside
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        !event.target.closest(".mobile-menu-button")
      ) {
        setShowMobileMenu(false);
      }

      // Close mobile search when clicking outside
      if (
        isMobile &&
        showSearch &&
        searchRef.current &&
        !searchRef.current.contains(event.target) &&
        !event.target.closest(".mobile-search-toggle")
      ) {
        setShowSearch(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobile, showSearch]);

  // Close settings menu when a settings modal is opened
  useEffect(() => {
    if (showSettingsModal) {
      setShowSettingsMenu(false);
      setShowJobSubmenu(false);
      setShowProjectSubmenu(false);
    }
  }, [showSettingsModal]);

  // Fetch unread count function
  const fetchUnreadCount = useCallback(async () => {
    try {
      const response = await fetch(
        `${apiUrl}/Notification/GetUnreadCount?userId=${userid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setUnreadCount(data.unreadCount);
        }
      }
    } catch (error) {
      console.error("Error fetching unread count:", error);
    }
  }, [apiUrl, userid]);

  const handleNewNotification = useCallback(() => {
    setUnreadCount((prevCount) => prevCount + 1);
  }, []);

  // Handle notification read from SignalR
  const handleNotificationRead = useCallback(() => {
    setUnreadCount((prevCount) => Math.max(prevCount - 1, 0));
  }, []);

  const handleAllNotificationsRead = useCallback(() => {
    setUnreadCount(0);
  }, []);

  useEffect(() => {
    let isMounted = true;

    const initializeNotifications = async () => {
      if (userid) {
        try {
          // Initialize SignalR connection
          await signalRService.startConnection(userid);

          // Fetch initial unread count
          await fetchUnreadCount();

          if (isMounted) {
            signalRService.addListener(
              "newNotification",
              handleNewNotification,
            );
            signalRService.addListener(
              "notificationRead",
              handleNotificationRead,
            );
            signalRService.addListener(
              "allNotificationsRead",
              handleAllNotificationsRead,
            );
          }
        } catch (error) {
          console.error("Failed to initialize SignalR:", error);
        }
      }
    };

    initializeNotifications();

    // Cleanup on unmount
    return () => {
      isMounted = false;
      signalRService.removeListener("newNotification", handleNewNotification);
      signalRService.removeListener("notificationRead", handleNotificationRead);
      signalRService.removeListener(
        "allNotificationsRead",
        handleAllNotificationsRead,
      );
    };
  }, [
    userid,
    fetchUnreadCount,
    handleNewNotification,
    handleNotificationRead,
    handleAllNotificationsRead,
  ]);

  const getUserDetails = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return {
      name: user?.userName || "User",
      email: user?.email || "user@example.com",
      id: user?.userId || userid,
    };
  };

  const getUserInitials = () => {
    const user = getUserDetails();
    const nameParts = user.name.trim().split(" ");
    if (nameParts.length === 1) return nameParts[0].charAt(0).toUpperCase();
    return (
      nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)
    ).toUpperCase();
  };

  useEffect(() => {
    if (showUserMenu) {
      setShowNotifications(false);
      setShowSettingsMenu(false);
      setShowJobSubmenu(false);
      setShowProjectSubmenu(false);
      setShowWorkspaceSubmenu(false);
    }
    if (showSettingsMenu) {
      setShowUserMenu(false);
      setShowNotifications(false);
      setShowJobSubmenu(false);
      setShowProjectSubmenu(false);
      setShowWorkspaceSubmenu(false);
    }
    if (showNotifications) {
      setShowUserMenu(false);
      setShowSettingsMenu(false);
      setShowJobSubmenu(false);
      setShowProjectSubmenu(false);
      setShowWorkspaceSubmenu(false);
    }
  }, [showUserMenu, showSettingsMenu, showNotifications]);

  const fetchUserWorkspaceRole = async () => {
    setIsRoleLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/UserWorkspace/GetWorkspacesByUserId/${userid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        const userWorkspaces = data.userWorkspaces || data || [];
        setUserWorkspaces(userWorkspaces);

        const workspace = userWorkspaces.find(
          (ws) =>
            (ws.workspaceID &&
              ws.workspaceID.toString() ===
                defaultUserWorkspaceID.toString()) ||
            (ws.workspaceId &&
              ws.workspaceId.toString() ===
                defaultUserWorkspaceID.toString()) ||
            (ws.id && ws.id.toString() === defaultUserWorkspaceID.toString()),
        );

        const newRole = workspace?.role || null;
        setRole(newRole);
      } else {
        console.error("API response not OK:", response.status);
      }
    } catch (error) {
      console.error("Error:", error);
      setRole(null);
    } finally {
      setIsRoleLoading(false);
    }
  };

  useEffect(() => {
    if (userid && defaultUserWorkspaceID) {
      fetchUserWorkspaceRole();
    }
  }, [userid, defaultUserWorkspaceID]);

  const user = getUserDetails();

  const shouldShowSettings = () => {
    return userRole === "Admin" || role === 1;
  };

  const handleProfileClick = () => {
    setShowUserProfileModal(true);
    setShowUserMenu(false);
    setShowMobileMenu(false);
    setShowSettingsMenu(false);
    setShowJobSubmenu(false);
    setShowProjectSubmenu(false);
    setShowWorkspaceSubmenu(false);
  };

  const handleSwitchWorkspaceClick = () => {
    setShowChangeWorkspaceModal(true);
    setShowUserMenu(false);
    setShowMobileMenu(false);
    setShowSettingsMenu(false);
    setShowJobSubmenu(false);
    setShowProjectSubmenu(false);
    setShowWorkspaceSubmenu(false);
  };

  const handleRequestWorkspaceClick = () => {
    setShowRequestWorkspaceOtpModal(true);
    setShowUserMenu(false);
    setShowMobileMenu(false);
    setShowSettingsMenu(false);
    setShowJobSubmenu(false);
    setShowProjectSubmenu(false);
    setShowWorkspaceSubmenu(false);
  };

  const handleOtpVerificationSuccess = (email) => {
    setVerifiedEmail(email);
    setShowRequestWorkspaceOtpModal(false);
    setTimeout(() => {
      setShowRequestWorkspaceModal(true);
    }, 300);
  };

  const handleWorkspaceChanged = (workspaceId, workspaceName) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      user.defaultWorkspaceName = workspaceName;
      localStorage.setItem("user", JSON.stringify(user));
    }
    window.location.reload();
  };

  const handleWorkspaceRequested = () => {
    console.log("Workspace requested successfully");
  };

  const toggleSearch = () => {
    setShowSearch(!showSearch);
    if (showSearch) {
      setSearchTerm("");
    }
  };

  const handleMobileViewChange = (mode) => {
    setViewMode(mode);
    setShowViewOptions(false);
  };

  // Function to handle Admin Dashboard click
  const handleAdminDashboardClick = () => {
    setShowSettingsMenu(false);
    setShowUserMenu(false);
    setShowJobSubmenu(false);
    setShowProjectSubmenu(false);
    setShowWorkspaceSubmenu(false);
    navigate("/admin-dashboard");
  };

  // Handle notification count update from component
  const handleNotificationCountUpdate = (count) => {
    setUnreadCount(count);
  };

  // Settings menu items handler
  const handleSettingsMenuItemClick = (menuId) => {
    let component = null;
    let title = "Settings";

    switch (menuId) {
      case "projectManagement":
        component = <ProjectManagement workspaceId={defaultUserWorkspaceID} />;
        title = "Project Management";
        break;
      case "projectPermission":
        component = (
          <ProjectPermissionManagement
            defId={defaultUserWorkspaceID}
            userId={userid}
          />
        );
        title = "Project Permissions";
        break;
      case "jobManagement":
        component = (
          <JobManagment
            defWorkId={defaultUserWorkspaceID}
            defaultworkspace={defWorkName}
          />
        );
        title = "Job Management";
        break;
      case "userManagement":
        if (userRole !== "User") {
          component = <UserManagement workspaceId={defaultUserWorkspaceID} />;
          title = "User Management";
        }
        break;
      case "jobPermissions":
        component = (
          <JobPermissionManagement
            defId={defaultUserWorkspaceID}
            userId={userid}
          />
        );
        title = "Job Permissions";
        break;
      case "jobStatus":
        component = <JobStatusManagement defId={defaultUserWorkspaceID} />;
        title = "Job Status Update";
        break;
      case "workspacePermission":
        component = (
          <WorkspacePermissionManagement defId={defaultUserWorkspaceID} />
        );
        title = "Workspace Permission";
        break;
      case "workspaceSettings":
        component = (
          <WorkspaceManagement
            onUpdateDefaultWorkspace={onUpdateDefaultWorkspace}
            userRole={userRole}
            workspaceRole={role}
            defWorkId={defaultUserWorkspaceID}
            defWorkName={defWorkName}
          />
        );
        title = "Workspace Settings";
        break;
      case "adminDashboard":
        handleAdminDashboardClick();
        return;
      default:
        break;
    }

    if (component) {
      setActiveSettingsComponent(component);
      setSettingsModalTitle(title);
      setShowSettingsModal(true);
      setShowSettingsMenu(false);
      setShowJobSubmenu(false);
      setShowProjectSubmenu(false);
      setShowWorkspaceSubmenu(false);
    }
  };

  // Handle job menu click - opens submenu
  const handleJobMenuClick = (e) => {
    e.stopPropagation();

    if (jobMenuButtonRef.current) {
      const rect = jobMenuButtonRef.current.getBoundingClientRect();
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const scrollX = window.scrollX || document.documentElement.scrollLeft;

      setShowProjectSubmenu(false);

      if (!isMobile) {
        setJobSubmenuPosition({
          top: rect.top + scrollY,
          left: rect.left + scrollX - 210,
        });
        setShowJobSubmenu(!showJobSubmenu);
      } else {
        const submenuTop = rect.bottom + scrollY + 5;
        const submenuLeft = Math.max(10, rect.left + scrollX - 90);

        setJobSubmenuPosition({
          top: submenuTop,
          left: submenuLeft,
        });
        setShowJobSubmenu(!showJobSubmenu);
      }
    }
  };

  const handleWorkspaceMenuClick = (e) => {
    e.stopPropagation();
    if (workspaceMenuButtonRef.current) {
      const rect = workspaceMenuButtonRef.current.getBoundingClientRect();
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const scrollX = window.scrollX || document.documentElement.scrollLeft;
      setShowJobSubmenu(false);
      setShowProjectSubmenu(false);
      if (!isMobile) {
        setWorkspaceSubmenuPosition({
          top: rect.top + scrollY,
          left: rect.left + scrollX - 210,
        });
        setShowWorkspaceSubmenu(!showWorkspaceSubmenu);
      } else {
        const submenuTop = rect.bottom + scrollY + 5;
        const submenuLeft = Math.max(10, rect.left + scrollX - 90);
        setWorkspaceSubmenuPosition({ top: submenuTop, left: submenuLeft });
        setShowWorkspaceSubmenu(!showWorkspaceSubmenu);
      }
    }
  };

  // Handle project menu click - opens submenu
  const handleProjectMenuClick = (e) => {
    e.stopPropagation();

    if (projectMenuButtonRef.current) {
      const rect = projectMenuButtonRef.current.getBoundingClientRect();
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const scrollX = window.scrollX || document.documentElement.scrollLeft;

      setShowJobSubmenu(false);

      if (!isMobile) {
        setProjectSubmenuPosition({
          top: rect.top + scrollY,
          left: rect.left + scrollX - 210,
        });
        setShowProjectSubmenu(!showProjectSubmenu);
      } else {
        const submenuTop = rect.bottom + scrollY + 5;
        const submenuLeft = Math.max(10, rect.left + scrollX - 90);

        setProjectSubmenuPosition({
          top: submenuTop,
          left: submenuLeft,
        });
        setShowProjectSubmenu(!showProjectSubmenu);
      }
    }
  };

  const toggleSettingsMenu = () => {
    const newShowSettingsMenu = !showSettingsMenu;
    setShowSettingsMenu(newShowSettingsMenu);
    setShowUserMenu(false);
    setShowNotifications(false);
    setShowJobSubmenu(false);
    setShowProjectSubmenu(false);
    setShowWorkspaceSubmenu(false);
  };

  // Function to close settings modal and reset component
  const closeSettingsModal = () => {
    setShowSettingsModal(false);
    setActiveSettingsComponent(null);
    setSettingsModalTitle("Settings");
  };

  const handleMobileSettings = () => {
    setActiveSettingsComponent(
      <div className="mobile-settings-default">
        <h3>Settings</h3>
        <p>Select an option from the settings menu</p>
      </div>,
    );
    setSettingsModalTitle("Settings");
    setShowSettingsModal(true);
    setShowUserMenu(false);
    setShowSettingsMenu(false);
    setShowJobSubmenu(false);
    setShowProjectSubmenu(false);
    setShowWorkspaceSubmenu(false);
  };

  const handleMobileNotifications = () => {
    setShowNotifications(!showNotifications);
    setShowUserMenu(false);
    setShowSettingsMenu(false);
    setShowJobSubmenu(false);
    setShowProjectSubmenu(false);
    setShowWorkspaceSubmenu(false);
  };

  const handleMobileRequestWorkspace = () => {
    setShowRequestWorkspaceOtpModal(true);
    setShowUserMenu(false);
    setShowSettingsMenu(false);
    setShowJobSubmenu(false);
    setShowProjectSubmenu(false);
    setShowWorkspaceSubmenu(false);
  };

  // Handle submenu item click
  const handleSubmenuItemClick = (menuId) => {
    handleSettingsMenuItemClick(menuId);
    setShowJobSubmenu(false);
    setShowProjectSubmenu(false);
    setShowSettingsMenu(false);
    setShowWorkspaceSubmenu(false);
  };

  return (
    <div className="dashboard-menu">
      <div className="menu-left">
        <i className="fas fa-clipboard-list menu-icon" />
        {!isMobile && (
          <span className="menu-title">
            Site Notes: {defaultUserWorkspaceName}
          </span>
        )}
      </div>

      <div className="menu-middle">
        {isMobile ? (
          <>
            <button
              className={`mobile-search-toggle ${showSearch ? "active" : ""}`}
              onClick={toggleSearch}
              title="Search"
            >
              <i className="fas fa-search" />
            </button>

            {showSearch && (
              <div ref={searchRef} className="search-container active">
                <div className="search-box-wrapper">
                  <input
                    id="searchInput"
                    type="text"
                    placeholder={
                      searchColumn
                        ? `Search by ${searchColumn}...`
                        : "Search notes..."
                    }
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                    }}
                    onKeyDown={handleSearchKeyDown}
                    className="search-input"
                  />
                  {searchTerm && (
                    <button
                      onClick={handleClearSearch}
                      className="clear-search-btn"
                      title="Clear search"
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>
            )}

            <button
              onClick={handleNewTaskModal}
              className="new-note-btn"
              title="New Note"
            >
              <i className="fas fa-plus" />
            </button>

            <div style={{ position: "relative" }}>
              <button
                className="view-options-button"
                onClick={() => setShowViewOptions(!showViewOptions)}
                title="View Options"
              >
                ...
              </button>

              {showViewOptions && (
                <div ref={viewOptionsRef} className="view-options-dropdown">
                  <div className="mobile-view-modes">
                    <button
                      onClick={() => handleMobileViewChange("table")}
                      className={`mobile-view-btn ${viewMode === "table" ? "active" : ""}`}
                      title="Table View"
                    >
                      <i className="fas fa-table" />
                    </button>
                    <button
                      onClick={() => handleMobileViewChange("cards")}
                      className={`mobile-view-btn ${viewMode === "cards" ? "active" : ""}`}
                      title="Card View"
                    >
                      <i className="fas fa-th" />
                    </button>
                    <button
                      onClick={() => handleMobileViewChange("stacked")}
                      className={`mobile-view-btn ${viewMode === "stacked" ? "active" : ""}`}
                      title="Stacked View"
                    >
                      <i className="fas fa-layer-group" />
                    </button>
                    <button
                      onClick={handleRefresh}
                      className={`mobile-view-btn`}
                      title="Refresh"
                    >
                      <i className="fas fa-refresh" />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="search-container">
              <div className="search-box-wrapper">
                <input
                  id="searchInput"
                  type="text"
                  placeholder={
                    searchColumn
                      ? `Search by ${searchColumn}...`
                      : "Search notes..."
                  }
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  onKeyDown={handleSearchKeyDown}
                  className="search-input"
                />
                {searchTerm && (
                  <button
                    onClick={handleClearSearch}
                    className="clear-search-btn"
                    title="Clear search"
                  >
                    ×
                  </button>
                )}
              </div>
              {searchColumn && (
                <span className="search-hint">
                  Searching in: {searchColumn}
                  <button
                    onClick={() => {
                      setSearchColumn("");
                      setSearchTerm("");
                    }}
                    className="clear-group-btn"
                  >
                    ×
                  </button>
                </span>
              )}
            </div>

            <div className="view-toggle-container">
              <button
                onClick={() => setViewMode("table")}
                className={`view-toggle-btn ${viewMode === "table" ? "active" : ""}`}
                title="Table View"
              >
                <i className="fas fa-table" />
              </button>
              <button
                onClick={() => setViewMode("cards")}
                className={`view-toggle-btn ${viewMode === "cards" ? "active" : ""}`}
                title="Card View"
              >
                <i className="fas fa-th" />
              </button>
              <button
                onClick={() => setViewMode("stacked")}
                className={`view-toggle-btn ${viewMode === "stacked" ? "active" : ""}`}
                title="Stacked View"
              >
                <i className="fas fa-layer-group" />
              </button>
              <button
                onClick={handleRefresh}
                className="refresh-btn"
                title="refresh"
              >
                <i className="fas fa-refresh" />
              </button>
            </div>

            <button onClick={handleNewTaskModal} className="new-note-btn">
              <i className="fas fa-plus-circle" /> New Task
            </button>
          </>
        )}
      </div>

      <div className="menu-right">
        {isMobile ? (
          <>
            {shouldShowSettings() && (
              <div
                className="mobile-settings-container"
                style={{ position: "relative" }}
              >
                <button
                  ref={mobileSettingsButtonRef}
                  onClick={toggleSettingsMenu}
                  className="mobile-settings-button"
                  title="Settings"
                >
                  <i className="fas fa-cog" />
                </button>

                {showSettingsMenu && (
                  <div
                    ref={settingsMenuRef}
                    className="settings-dropdown mobile-settings-dropdown"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="settings-dropdown-header">
                      <span>Settings</span>
                    </div>

                    <div className="dropdown-divider"></div>

                    <div
                      className="dropdown-item has-submenu"
                      ref={projectMenuButtonRef}
                      onClick={handleProjectMenuClick}
                    >
                      <i className="fas fa-project-diagram dropdown-icon" />
                      <span className="dropdown-text">Project Management</span>
                      <i
                        className={`fas ${showProjectSubmenu ? "fa-chevron-up" : "fa-chevron-down"} submenu-arrow`}
                      />
                    </div>

                    <div
                      className="dropdown-item has-submenu"
                      ref={jobMenuButtonRef}
                      onClick={handleJobMenuClick}
                    >
                      <i className="fas fa-tasks dropdown-icon" />
                      <span className="dropdown-text">Job Management</span>
                      <i
                        className={`fas ${showJobSubmenu ? "fa-chevron-up" : "fa-chevron-down"} submenu-arrow`}
                      />
                    </div>

                    {userRole !== "User" && (
                      <button
                        className="dropdown-item"
                        onClick={() =>
                          handleSettingsMenuItemClick("userManagement")
                        }
                      >
                        <i className="fas fa-user-plus dropdown-icon" />
                        <span className="dropdown-text">User Management</span>
                      </button>
                    )}

                    <div className="dropdown-divider"></div>

                    <div
                      className="dropdown-item has-submenu"
                      ref={workspaceMenuButtonRef}
                      onClick={handleWorkspaceMenuClick}
                    >
                      <i className="fas fa-building dropdown-icon" />
                      <span className="dropdown-text">
                        Workspace Management
                      </span>
                      <i
                        className={`fas ${showWorkspaceSubmenu ? "fa-chevron-up" : "fa-chevron-down"} submenu-arrow`}
                      />
                    </div>

                    {userRole === "Admin" && (
                      <button
                        className="dropdown-item admin-dashboard-item"
                        onClick={() =>
                          handleSettingsMenuItemClick("adminDashboard")
                        }
                      >
                        <i className="fas fa-tachometer-alt dropdown-icon" />
                        <span className="dropdown-text">Admin Dashboard</span>
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}
            <div style={{ position: "relative" }}>
              <button
                  ref={notificationsButtonRef}
                  className="notifications-button mobile-notifications-button"
                  onClick={() => {
                    setShowNotifications(!showNotifications);
                    setShowUserMenu(false);
                    setShowSettingsMenu(false);
                    setShowJobSubmenu(false);
                    setShowProjectSubmenu(false);
                  }}
                  title="Notifications"
              >
                <i className="fas fa-bell" />
                {unreadCount > 0 && (
                    <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
                )}
              </button>

              {showNotifications && (
                  <div
                      ref={notificationsRef}
                      className="notifications-dropdown mobile-notifications-dropdown"
                      onClick={(e) => e.stopPropagation()}
                  >
                    <NotificationComponent
                        userId={userid}
                        onClose={() => setShowNotifications(false)}
                        onNotificationCountUpdate={handleNotificationCountUpdate}
                        onNavigateToNote={onHighlightNote}
                    />
                  </div>
              )}
            </div>

            {isMobile && showProjectSubmenu && (
              <div
                ref={projectSubmenuRef}
                className="project-submenu mobile-project-submenu"
                style={{
                  position: "fixed",
                  top: `${projectSubmenuPosition.top}px`,
                  left: `${Math.max(10, Math.min(projectSubmenuPosition.left, window.innerWidth - 210))}px`,
                  zIndex: 1006,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="submenu-header">
                  <span>Project Management</span>
                </div>

                <div className="submenu-divider"></div>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("projectManagement")}
                >
                  <i className="fas fa-edit submenu-icon" />
                  <span className="submenu-text">Add/Edit Project</span>
                </button>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("projectPermission")}
                >
                  <i className="fas fa-user-shield submenu-icon" />
                  <span className="submenu-text">Project Permissions</span>
                </button>
              </div>
            )}

            {isMobile && showJobSubmenu && (
              <div
                ref={jobSubmenuRef}
                className="job-submenu mobile-job-submenu"
                style={{
                  position: "fixed",
                  top: `${jobSubmenuPosition.top}px`,
                  left: `${Math.max(10, Math.min(jobSubmenuPosition.left, window.innerWidth - 210))}px`,
                  zIndex: 1006,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="submenu-header">
                  <span>Job Management</span>
                </div>

                <div className="submenu-divider"></div>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("jobManagement")}
                >
                  <i className="fas fa-tasks submenu-icon" />
                  <span className="submenu-text">Add/Edit Job</span>
                </button>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("jobPermissions")}
                >
                  <i className="fas fa-user-shield submenu-icon" />
                  <span className="submenu-text">Job Permissions</span>
                </button>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("jobStatus")}
                >
                  <i className="fas fa-sync-alt submenu-icon" />
                  <span className="submenu-text">Job Status Update</span>
                </button>
              </div>
            )}

            {isMobile && showWorkspaceSubmenu && (
              <div
                ref={workspaceSubmenuRef}
                className="workspace-submenu mobile-workspace-submenu"
                style={{
                  position: "fixed",
                  top: `${workspaceSubmenuPosition.top}px`,
                  left: `${Math.max(10, Math.min(workspaceSubmenuPosition.left, window.innerWidth - 210))}px`,
                  zIndex: 1006,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="submenu-header">
                  <span>Workspace Management</span>
                </div>

                <div className="submenu-divider"></div>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("workspacePermission")}
                >
                  <i className="fas fa-user-shield submenu-icon" />
                  <span className="submenu-text">Workspace Permissions</span>
                </button>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("workspaceSettings")}
                >
                  <i className="fas fa-building submenu-icon" />
                  <span className="submenu-text">Workspace Settings</span>
                </button>
              </div>
            )}

            <div className="user-menu-container mobile-user-menu-container">
              <button
                ref={userAvatarRef}
                onClick={() => {
                  setShowUserMenu(!showUserMenu);
                  setShowSettingsMenu(false);
                  setShowNotifications(false);
                  setShowJobSubmenu(false);
                  setShowProjectSubmenu(false);
                }}
                className="user-avatar mobile-user-avatar"
                title={user.name}
              >
                {getUserInitials()}
              </button>

              {showUserMenu && (
                <div
                  ref={userMenuRef}
                  className="user-dropdown mobile-user-dropdown"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="user-info-section">
                    <div className="user-avatar-large">{getUserInitials()}</div>
                    <div className="user-details">
                      <div className="user-name">{user.name}</div>
                      <div className="user-email">{user.email}</div>
                      <div className="user-workspace">
                        {defaultUserWorkspaceName}
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-divider"></div>



                  <button
                    className="dropdown-item"
                    onClick={handleProfileClick}
                  >
                    <i className="fas fa-user-circle dropdown-icon" />
                    <span className="dropdown-text">Profile</span>
                  </button>

                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item"
                    onClick={handleMobileRequestWorkspace}
                  >
                    <i className="fas fa-plus-square dropdown-icon" />
                    <span className="dropdown-text">Request Workspace</span>
                  </button>

                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item"
                    onClick={handleSwitchWorkspaceClick}
                  >
                    <i className="fas fa-exchange-alt dropdown-icon" />
                    <span className="dropdown-text">Switch Workspace</span>
                  </button>

                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item logout-item"
                    onClick={() => {
                      onLogout();
                      setShowUserMenu(false);
                    }}
                  >
                    <i className="fas fa-sign-out-alt dropdown-icon" />
                    <span className="dropdown-text">Log out</span>
                  </button>
                </div>
              )}
            </div>

            {showNotifications && (
              <div
                ref={notificationsRef}
                className="notifications-dropdown mobile-notifications-dropdown"
                onClick={(e) => e.stopPropagation()}
              >
                <NotificationComponent
                  userId={userid}
                  onClose={() => setShowNotifications(false)}
                  onNotificationCountUpdate={handleNotificationCountUpdate}
                  onNavigateToNote={onHighlightNote}
                />
              </div>
            )}
          </>
        ) : (
          <>
            {/* Desktop Notifications Button */}
            <div style={{ position: "relative" }}>
              <button
                ref={notificationsButtonRef}
                className="notifications-button"
                onClick={() => {
                  setShowNotifications(!showNotifications);
                  setShowUserMenu(false);
                  setShowSettingsMenu(false);
                  setShowJobSubmenu(false);
                  setShowProjectSubmenu(false);
                }}
                title="Notifications"
              >
                <i className="fas fa-bell" />
                {unreadCount > 0 && (
                  <span className="notification-badge">
                    {unreadCount > 99 ? "99+" : unreadCount}
                  </span>
                )}
              </button>

              {showNotifications && (
                <div
                  ref={notificationsRef}
                  className="notifications-dropdown"
                  onClick={(e) => e.stopPropagation()}
                >
                  <NotificationComponent
                    userId={userid}
                    onClose={() => setShowNotifications(false)}
                    onNotificationCountUpdate={handleNotificationCountUpdate}
                    onNavigateToNote={onHighlightNote}
                  />
                </div>
              )}
            </div>

            {shouldShowSettings() && (
              <div
                className="settings-menu-container"
                style={{ position: "relative" }}
              >
                <button
                  ref={settingsButtonRef}
                  onClick={toggleSettingsMenu}
                  className="settings-button"
                  title="Settings"
                >
                  <i className="fas fa-cog" />
                </button>

                {showSettingsMenu && (
                  <div
                    ref={settingsMenuRef}
                    className="settings-dropdown"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="settings-dropdown-header">
                      <span>Settings</span>
                    </div>

                    <div className="dropdown-divider"></div>

                    <div
                      className="dropdown-item has-submenu"
                      ref={projectMenuButtonRef}
                      onClick={handleProjectMenuClick}
                    >
                      <i className="fas fa-project-diagram dropdown-icon" />
                      <span className="dropdown-text">Project Management</span>
                      <i
                        className={`fas ${showProjectSubmenu ? "fa-chevron-left" : "fa-chevron-right"} submenu-arrow`}
                      />
                    </div>

                    <div
                      className="dropdown-item has-submenu"
                      ref={jobMenuButtonRef}
                      onClick={handleJobMenuClick}
                    >
                      <i className="fas fa-tasks dropdown-icon" />
                      <span className="dropdown-text">Job Management</span>
                      <i
                        className={`fas ${showJobSubmenu ? "fa-chevron-left" : "fa-chevron-right"} submenu-arrow`}
                      />
                    </div>

                    {userRole !== "User" && (
                      <button
                        className="dropdown-item"
                        onClick={() =>
                          handleSettingsMenuItemClick("userManagement")
                        }
                      >
                        <i className="fas fa-user-plus dropdown-icon" />
                        <span className="dropdown-text">User Management</span>
                      </button>
                    )}

                    <div className="dropdown-divider"></div>

                    <div
                      className="dropdown-item has-submenu"
                      ref={workspaceMenuButtonRef}
                      onClick={handleWorkspaceMenuClick}
                    >
                      <i className="fas fa-building dropdown-icon" />
                      <span className="dropdown-text">
                        Workspace Management
                      </span>
                      <i
                        className={`fas ${showWorkspaceSubmenu ? "fa-chevron-left" : "fa-chevron-right"} submenu-arrow`}
                      />
                    </div>

                    {userRole === "Admin" && (
                      <button
                        className="dropdown-item admin-dashboard-item"
                        onClick={() =>
                          handleSettingsMenuItemClick("adminDashboard")
                        }
                      >
                        <i className="fas fa-tachometer-alt dropdown-icon" />
                        <span className="dropdown-text">Admin Dashboard</span>
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Desktop Submenus */}
            {showProjectSubmenu && !isMobile && (
              <div
                ref={projectSubmenuRef}
                className="project-submenu desktop-project-submenu"
                style={{
                  position: "fixed",
                  top: `${projectSubmenuPosition.top}px`,
                  left: `${projectSubmenuPosition.left}px`,
                  zIndex: 1005,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="submenu-header">
                  <span>Project Management</span>
                </div>

                <div className="submenu-divider"></div>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("projectManagement")}
                >
                  <i className="fas fa-edit submenu-icon" />
                  <span className="submenu-text">Add/Edit Project</span>
                </button>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("projectPermission")}
                >
                  <i className="fas fa-user-shield submenu-icon" />
                  <span className="submenu-text">Project Permissions</span>
                </button>
              </div>
            )}

            {showJobSubmenu && !isMobile && (
              <div
                ref={jobSubmenuRef}
                className="job-submenu desktop-job-submenu"
                style={{
                  position: "fixed",
                  top: `${jobSubmenuPosition.top}px`,
                  left: `${jobSubmenuPosition.left}px`,
                  zIndex: 1005,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="submenu-header">
                  <span>Job Management</span>
                </div>

                <div className="submenu-divider"></div>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("jobManagement")}
                >
                  <i className="fas fa-edit submenu-icon" />
                  <span className="submenu-text">Add/Edit Job</span>
                </button>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("jobPermissions")}
                >
                  <i className="fas fa-user-shield submenu-icon" />
                  <span className="submenu-text">Job Permissions</span>
                </button>

                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("jobStatus")}
                >
                  <i className="fas fa-sync-alt submenu-icon" />
                  <span className="submenu-text">Job Status Update</span>
                </button>
              </div>
            )}

            {showWorkspaceSubmenu && !isMobile && (
              <div
                ref={workspaceSubmenuRef}
                className="workspace-submenu desktop-workspace-submenu"
                style={{
                  position: "fixed",
                  top: `${workspaceSubmenuPosition.top}px`,
                  left: `${workspaceSubmenuPosition.left}px`,
                  zIndex: 1005,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="submenu-header">
                  <span>Workspace Management</span>
                </div>

                <div className="submenu-divider"></div>
                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("workspacePermission")}
                >
                  <i className="fas fa-user-shield submenu-icon" />
                  <span className="submenu-text">Workspace Permissions</span>
                </button>
                <button
                  className="submenu-item"
                  onClick={() => handleSubmenuItemClick("workspaceSettings")}
                >
                  <i className="fas fa-building submenu-icon" />
                  <span className="submenu-text">Workspace Settings</span>
                </button>
              </div>
            )}

            <div className="user-menu-container">
              <button
                ref={userAvatarRef}
                onClick={() => {
                  setShowUserMenu(!showUserMenu);
                  setShowSettingsMenu(false);
                  setShowNotifications(false);
                  setShowJobSubmenu(false);
                  setShowProjectSubmenu(false);
                }}
                className="user-avatar"
                title={user.name}
              >
                {getUserInitials()}
              </button>

              {showUserMenu && (
                <div
                  ref={userMenuRef}
                  className="user-dropdown"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="user-info-section">
                    <div className="user-avatar-large">{getUserInitials()}</div>
                    <div className="user-details">
                      <div className="user-name">{user.name}</div>
                      <div className="user-email">{user.email}</div>
                    </div>
                  </div>

                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item"
                    onClick={handleProfileClick}
                  >
                    <i className="fas fa-user-circle dropdown-icon" />
                    <span className="dropdown-text">Profile</span>
                  </button>
                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item"
                    onClick={handleRequestWorkspaceClick}
                  >
                    <i className="fas fa-plus-square dropdown-icon" />
                    <span className="dropdown-text">Request Workspace</span>
                  </button>

                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item"
                    onClick={handleSwitchWorkspaceClick}
                  >
                    <i className="fas fa-exchange-alt dropdown-icon" />
                    <span className="dropdown-text">Switch Workspace</span>
                  </button>

                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item logout-item"
                    onClick={() => {
                      onLogout();
                      setShowUserMenu(false);
                    }}
                  >
                    <i className="fas fa-sign-out-alt dropdown-icon" />
                    <span className="dropdown-text">Log out</span>
                  </button>
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {/* Settings Modal */}
      <Modal
        isOpen={showSettingsModal}
        onClose={closeSettingsModal}
        title={settingsModalTitle}
        className="modal-sm"
      >
        {activeSettingsComponent}
      </Modal>

      {/* Other modals */}
      {showChangeWorkspaceModal && (
        <ChangeWorkspaceModal
          isOpen={showChangeWorkspaceModal}
          onClose={() => setShowChangeWorkspaceModal(false)}
          ownerUserID={user.id}
          onUpdateDefaultWorkspace={onUpdateDefaultWorkspace}
          onWorkspaceChanged={handleWorkspaceChanged}
        />
      )}

      {showRequestWorkspaceOtpModal && (
        <RequestWorkspaceOtpModal
          isOpen={showRequestWorkspaceOtpModal}
          onClose={() => setShowRequestWorkspaceOtpModal(false)}
          onVerificationSuccess={handleOtpVerificationSuccess}
          existingEmail={user.email || ""}
        />
      )}

      {showRequestWorkspaceModal && (
        <RequestWorkspaceModal
          isOpen={showRequestWorkspaceModal}
          onClose={() => setShowRequestWorkspaceModal(false)}
          ownerUserID={user.id}
          onWorkspaceAdded={handleWorkspaceRequested}
          verifiedEmail={verifiedEmail}
        />
      )}

      {showUserProfileModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowUserProfileModal(false)}
        >
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>User Profile</h2>
              <button
                className="modal-close-btn"
                onClick={() => setShowUserProfileModal(false)}
              >
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <UserProfile userid={userid} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default DashboardMenu;
